import { useEffect, useState } from 'react';
import slugify from '../../../../core/commom/slugify';
import { iButtonGroupProps } from '../../../../core/components/organism/ButtonGroup';
import { useUrlSearchParams } from '../../../../core/hooks/useCustomSearchParams';

function useAprovaLivePage() {
  const defaultTab = 'cronograma';
  const { setUrlParam, getUrlParam } = useUrlSearchParams();
  const [selectedTab, setSelectedTab] = useState<string>();

  const [tabsButtons, setTabsButtons] = useState<iButtonGroupProps>({
    buttons: [
      {
        label: 'Cronograma',
        onClick: () => {
          setSelectedTab('cronograma');
        },
      },
      {
        label: 'Aulas gravadas',
        onClick: () => {
          setSelectedTab('aulas-gravadas');
        },
      },
      {
        label: 'Simulados',
        onClick: () => {
          setSelectedTab('simulados');
        },
      },
    ],
  });

  function handleChangeTab(tab: string) {
    updateButtonsTab(tab);
    setUrlParam('tab', tab);
  }

  function updateButtonsTab(tab: string) {
    const newButtons = tabsButtons.buttons.map((button) => {
      if (slugify(button.label) === tab) {
        return { ...button, selected: true };
      }

      return { ...button, selected: false };
    });

    const newTabsButtons = { ...tabsButtons, buttons: newButtons };

    setTabsButtons(newTabsButtons);
  }

  useEffect(() => {
    const initialTab = getUrlParam('tab');
    const tab = initialTab ?? defaultTab;
    setSelectedTab(tab);
  }, []);

  useEffect(() => {
    if (selectedTab) {
      handleChangeTab(selectedTab);
    }
  }, [selectedTab]);

  return {
    tabsButtons,
    selectedTab,
    handleChangeTab,
  };
}

export { useAprovaLivePage };
